import dayjs from 'dayjs';
import { message as antdMessage } from 'antd';

const PERIOD_TAKEN_MESSAGE = 'La période est déjà prise en compte';

const isPeriodOverlappingRates = (rates, values, showWarning) => {
  let found = false;
  rates.forEach((rate) => {
    if (
      dayjs(values.rate.application_date).startOf('day') <=
        dayjs(rate.application_date) &&
      dayjs(values.rate.end_date).endOf('day') >= dayjs(rate.end_date)
    ) {
      if (!found) {
        showWarning(PERIOD_TAKEN_MESSAGE);
        found = true;
      }
    }
  });
  return found;
};

export const onFinishForm = async ({
  values,
  purpose,
  supervisionPrice,
  dispatchAPI,
  priceToEdit,
  onClose,
  setTVA,
  setTotalHT,
  setRefreshData,
  refreshData,
  message
}) => {
  try {
    const ratesToCheck =
      purpose === 'create'
        ? supervisionPrice.rates.filter((el) => !el.default)
        : supervisionPrice.rates
            .filter((el) => el._id !== priceToEdit._id)
            .filter((el) => !el.default);

    if (isPeriodOverlappingRates(ratesToCheck, values, antdMessage.warning)) {
      return;
    }

    if (purpose === 'create') {
      await dispatchAPI('PATCH', {
        url: `/supervisionprices/${supervisionPrice._id}?type=add_price`,
        body: values.rate
      });
    } else {
      await dispatchAPI('PATCH', {
        url: `/supervisionprices/${supervisionPrice._id}?type=edit_price&price_to_edit=${priceToEdit._id}`,
        body: values.rate
      });
    }
    onClose();
    setTVA(null);
    setTotalHT(null);
    setRefreshData(!refreshData);
  } catch (e) {
    if (e.response) message(e.response.status);
  }
};
